export const decisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizing =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/get_agent_is_personalizing";
